import { Dictionary } from '@blocknote/core';
import { en, es, pt } from '@blocknote/core/locales';
import { t } from 'i18next';

import i18n from '@/i18n/i18n';

const localeMap: Record<string, Dictionary> = { en, es, pt };

const getLanguageDictionary = () => localeMap[i18n.language?.split('-')[0]] || en;

export const getGuidelinesEditorDefaults = () => {
  return { dictionary: getLanguageDictionary() };
};

export const getGuidelinesEditorOverrides = (overrides?: { defaultPlaceholder?: string }) => {
  const languageDictionary = getLanguageDictionary();

  return {
    dictionary: {
      ...languageDictionary,
      placeholders: {
        ...languageDictionary.placeholders,
        default:
          overrides?.defaultPlaceholder ?? t('ai_agents.guidelines_editor_overrides.default'),
        heading: t('ai_agents.guideline'),
      } as Dictionary['placeholders'],
      slash_menu: {
        ...languageDictionary.slash_menu,

        paragraph: {
          title: t('ai_agents.guidelines_editor_overrides.paragraph.title'),
          subtext: t('ai_agents.guidelines_editor_overrides.paragraph.description'),
          aliases: ['p', 'paragraph'],
          group: 'Basic blocks',
        },
        bullet_list: {
          title: t('ai_agents.guidelines_editor_overrides.bullet_list.title'),
          subtext: t('ai_agents.guidelines_editor_overrides.bullet_list.description'),
          aliases: ['bl', 'bulletlist', 'bullet_list', 'ul', 'unorderedlist', 'unordered_list'],
          group: 'Lists',
        },
        numbered_list: {
          title: t('ai_agents.guidelines_editor_overrides.numbered_list.title'),
          subtext: t('ai_agents.guidelines_editor_overrides.numbered_list.description'),
          aliases: ['nl', 'numberedlist', 'numbered_list', 'ol', 'orderedlist', 'ordered_list'],
          group: 'Lists',
        },
        heading_2: {
          title: t('ai_agents.guidelines_editor_overrides.heading2.title'),
          subtext: t('ai_agents.guidelines_editor_overrides.heading2.description'),
          aliases: ['h2', 'heading2', 'heading_2'],
          group: 'Headings',
        },
      } as Dictionary['slash_menu'],
    },
  };
};
